module.exports = __webpack_public_path__ + "img/text_inspector_llenas.0635e1e8.png";